export const clearProfilesFromSessionStorage = () => {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (!key) continue;

    const raw = sessionStorage.getItem(key);
    if (!raw) continue;

    try {
      const parsed = JSON.parse(raw);

      if (parsed && typeof parsed === 'object' && 'profiles' in parsed) {
        const { profiles, ...rest } = parsed;

        if (Object.keys(rest).length > 0) {
          sessionStorage.setItem(key, JSON.stringify(rest));
        } else {
          sessionStorage.removeItem(key);
        }
      }
    } catch (err) {
      // ⛑ защитный catch — НЕ ошибка пользователя
      if (process.env.NODE_ENV === 'development') {
        console.warn(
          `[clearProfilesFromSessionStorage] Skip non-JSON sessionStorage key: ${key}`,
          err,
        );
      }
    }
  }
};
